<template>
    <div class="p-col-12">
        <page-header title="forms.contract.title"/>
        <form @submit.prevent="save">
            <card :header="$t('forms.contract.card-title-information')" class="p-col-12">
              <coff-input-text v-model="form.name" label="forms.contract.name" class="p-col-12 p-md-6 p-lg-4" :error="validation.name" />
              <coff-input-text v-model="form.installmentsGroupName" label="forms.contract.fragmentGroup" class="p-col-12 p-md-6 p-lg-4" :error="validation.installmentsGroupName" />
              <coff-input-radio v-model="form.active" @update="forceUpdateField('active', $event)" :options="options" label="forms.contract.isActive" class="p-col-12 p-md-4 p-lg-2" :error="validation.active"/>

              <hr style="width: 100%;"/>
              <coff-input-text-editor v-model="form.text" label="forms.contract.text" class="p-col-12" :error="validation.text"/>

            </card>
            <div class="p-col-12">
                <Button :label="$t('btn.save&continue')" class="p-button-success" style="float: right;"/>
            </div>
        </form>
    </div>
</template>

<script>

    import ValidationUtils from "@/utils/ValidationUtils";
    import ToastMessageBusiness from "@/business/ToastMessageBusiness";
    import EventBus from "@/commons/EventBus";
    import PageHeader from "@/components/page/PageHeader";
    import ContractBusiness from "@/business/ContractBusiness";

    export default {
        name: "ContractForm",
        components: {PageHeader},
        data(){
            return {
                form: {
                },
                validation: {
                  name: false,
                  installmentsGroupName: false,
                  active: false,
                  text: false,
                },
                options: [
                    {value: true, label: 'field.default.yes'},
                    {value: false, label: 'field.default.no'}
                ],
            }
        },

        async mounted(){
            const id = this.$route.params.id;
            if(id){
                EventBus.loadingPage(true);
                this.form =  {... await ContractBusiness.getById(id)};
                EventBus.loadingPage(false);
            }
        },
        methods:{

          forceUpdateField(field, value){
            this.$set(this.form, field, value);
          },

          async save(){
            this.validation = ValidationUtils.basicValidation(this.validation, this.form);
              if(!this.validation.erros){
                  const response = await ContractBusiness.save(this.form, this.form.id).catch((e) => ToastMessageBusiness.showError(e.message));
                  if(response){
                      this.form = response;
                      ToastMessageBusiness.showSuccess();
                  }
              }
          },

        }
    }
</script>

<style scoped>

</style>
